var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSwapVerticle = function SvgSwapVerticle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 13.26a16.797 16.797 0 0 0 3.003 3.124.527.527 0 0 0 .33.116m3.333-3.24a16.796 16.796 0 0 1-3.003 3.124.527.527 0 0 1-.33.116m0 0V4.833m-10-.094a16.796 16.796 0 0 1 3.003-3.123.527.527 0 0 1 .33-.116M8 4.74a16.795 16.795 0 0 0-3.003-3.124.527.527 0 0 0-.33-.116m0 0v11.667"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSwapVerticle);
export default ForwardRef;